module.exports = __webpack_public_path__ + "img/projetct_home.a35db7f3.png";